<template>
  <div>
    <div class="bg-white shadow-sm fixed-top PcDevice">
      <nav class="navbar  navbar-expand-lg mx-3 py-1">
        <!-- 目前是非登入狀態所以先關閉，要判定當開展時就要連到Home -->

        <a class="navbar-brand WidthLongLogo">
          <img src="../../assets/images/Exhibition_Logo.jpg" height="85px" alt="" />
        </a>

        <a class="navbar-brand WidthShortLogo">
          <img src="../../assets/images/Mb_Exhibition_Logo.jpg" height="85px" alt="" />
        </a>

        <div class="collapse navbar-collapse">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active"></li>
          </ul>

          <div v-if="isLogin && OnlineExpoStatus !== 3">
            <button class="btn btn-warning px-5 py-2 mr-4" @click.prevent="logout()">
              Logout
            </button>
          </div>

          <div class="d-flex align-items-center mt-1" v-if="OnlineExpoStatus !== 3">
            <div class="mr-2">
              <i style="font-size:32px" class="fas fa-home"></i>
            </div>
            <div style="font-size:15px" class="pointer ">
              <div class="BannerHover" @click.prevent="toWebsiteCn">參展品牌預覽</div>
              <div class="BannerHover" @click.prevent="toWebsiteEn"><i>Exhibitor List Preview</i></div>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <div class="bg-white shadow-sm fixed-top MbDevice">
      <div class="container ">
        <div class="row justify-content-between align-items-center">
          <div style="margin-left:4px">
            <router-link to="/Landing">
              <a class="navbar-brand">
                <img src="../../assets/images/Mb_Exhibition_Logo.jpg" width="210px" height="70px" alt="" />
              </a>
            </router-link>
          </div>

          <div style="margin-right:4px;margin-top:10px" v-if="OnlineExpoStatus !== 3">
            <div class="d-flex align-items-center">
              <div>
                <i style="font-size:25px" class="fas fa-home"></i>
              </div>
              <div class="ml-1 pointer ">
                <div class="BannerHover" style="font-size:12px" @click.prevent="toWebsiteCn">
                  品牌預覽
                </div>
                <div class="small-font BannerHover" @click.prevent="toWebsiteEn"><i>Exhibitor Preview</i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-white lobby_bg titleMargin">
      <div class="container-fluid">
        <!-- 未開展專區 -->
        <div v-if="OnlineExpoStatus == 1">
          <div class="row justify-content-start">
            <div class="col-lg-6 mx-4">
              <p>&zwnj;</p>

              <div v-if="!isLogin">
                <div class=" loginAllfont_1">
                  <div class="loginTopfont_1 mt-4">
                    Coming Soon!
                  </div>

                  <div class="mt-3">
                    The real-time interaction virtual platform for the Coffee industry.
                  </div>

                  <div class="mb-2">
                    Please login first to enter the online exhibition.
                  </div>

                  <!-- <div class=" loginNoticefont_1" style="color:#ff1315">
                    Notice: The online exhibition ticket redemption will expire before 23:59 (GMT+8) November 14, 2022.
                  </div> -->

                  <p class="mt-3 loginTimefont_1">
                    15 - 24 November, 2022
                  </p>
                  <div class="Opentime mb-3" style="color:#ff1315">
                    The Online Expo will be available on November 15, 2022 at 10:00(GMT+8).
                  </div>
                </div>
              </div>

              <div v-if="isLogin && !isRegister">
                <div class="registerAllfont_1">
                  <div class="registerTopfont_1 mt-4">
                    Hello, our distinguished member! <br />
                    We will see you soon on 15 - 24 November, 2022.
                  </div>

                  <div class="mt-4">
                    We detected that you haven’t finished the online exhibition ticket redemption procedure.
                  </div>

                  <div class="mt-2 mb-1">
                    Please complete the online ticket redemption first, and looking forward to meeting you on 15 – 24
                    November, 2022.
                  </div>

                  <div class="Opentime mb-2" style="color:#ff1315">
                    The online exhibition ticket redemption will expire before 23:59 (GMT+8) November 14, 2022.
                  </div>
                </div>
              </div>

              <div v-if="isLogin && isRegister">
                <div class="doneAllfont_1">
                  <div class="doneTopfont_1 mt-4">
                    You’ve finished the online exhibition registration! We will meet you soon on 15 – 24 November, 2022.
                  </div>

                  <div class="Opentime mt-3 " style="color:#ff1315">
                    The Online Expo will be available on November 15, 2022 at 10:00(GMT+8).
                  </div>

                  <div class="mt-4">
                    Thank you for registering the Taiwan International Coffee Show Online Exhibition.
                  </div>

                  <div class="my-3">
                    Hope you will have a delightful experience with us. Before that, you are welcome to visit our
                    official website for further information.
                  </div>

                  <div class="my-3"></div>
                </div>
              </div>

              <p>&nbsp;</p>
              <div v-if="!isLogin">
                <span class="PcDevice">
                  <div class="btn btn-outline-light px-5 py-3 mt-4 " @click="toLogin">Login</div>
                </span>
                <span class="MbDevice">
                  <div class="btn btn-outline-light px-5 py-2 mt-4 " @click="toLogin">Login</div>
                </span>
              </div>

              <div v-if="isLogin && !isRegister">
                <div class="btn btn-outline-light px-5 py-3 mt-4" @click.prevent="toRegistration">
                  Ticket Redemption
                </div>
              </div>

              <div v-if="isLogin && isRegister">
                <div class="btn btn-outline-light px-5 py-3 mt-4" @click.prevent="OpenOfficialUrl">
                  Official Website
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 已開展 -->
        <div v-if="OnlineExpoStatus == 2">
          <div class="row justify-content-start">
            <div class="col-lg-6 ml-5">
              <p>&zwnj;</p>
              <p>&zwnj;</p>

              <div v-if="!isLogin">
                <div>
                  <div class="mt-3 loginTopfont_2">
                    The real-time interaction virtual platform for the Coffee industry.
                  </div>

                  <div class="mt-3 loginAllfont_2">
                    Please login to enter the online exhibition lobby.
                  </div>

                  <p class=" mt-4  loginTimefont_2">
                    15 - 24 November, 2022
                  </p>
                  <!-- <div class="Opentime mb-3">（The Online Expo will be available on 4 November at 10:00(GMT+8)）</div> -->
                </div>
              </div>

              <div v-if="isLogin && !isRegister">
                <div class="registerAllfont_2">
                  <div class="registerTopfont_2">
                    The online exhibition ticket redemption has expired on November 14, 2022.
                  </div>

                  <div class="my-4">
                    For more Taiwan International Coffee Show information, please proceed to the official website.
                  </div>
                </div>
              </div>

              <div v-if="isLogin && isRegister">
                <p>&zwnj;</p>
                <p>&zwnj;</p>
              </div>

              <p>&nbsp;</p>
              <div v-if="isLogin && !isRegister">
                <div class="btn btn-outline-light px-5 py-3 mt-4" @click="OpenOfficialUrl">Official Website</div>
              </div>

              <div v-if="!isLogin">
                <span class="PcDevice">
                  <div class="btn btn-outline-light px-5 py-3 mt-4 " @click="toLogin">Login</div>
                </span>
                <span class="MbDevice">
                  <div class="btn btn-outline-light px-5 py-2 mt-4 " @click="toLogin">Login</div>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 展場結束 -->

        <div v-if="OnlineExpoStatus == 3">
          <div class="row justify-content-start">
            <div class="col-lg-6 ml-5">
              <p>&zwnj;</p>
              <p>&zwnj;</p>
              <div class="closeAllfont_3">
                <div class="closeTopfont_3 mt-4">
                  The online expo has ended.
                </div>
                <div class="mt-4">
                  See you in next time!
                </div>

                <p>&zwnj;</p>

                <div class="btn btn-outline-light px-5 py-3 mt-4" @click.prevent="toOfficialUrl">
                  Back to official website
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        isLogin: false,
        isRegister: true,
        OnlineExpoStatus: '',
        Nowdate: '',
        ExpoBegin: '',
        ExpoEnd: '',
      }
    },

    methods: {
      toWebsiteCn() {
        window.open(`https://www.chanchao.com.tw/coffee/visitorExhibitor.asp`)
      },

      toWebsiteEn() {
        window.open(`https://www.chanchao.com.tw/coffee/en/visitorExhibitor.asp`)
      },

      OpenOfficialUrl() {
        window.open('https://www.chanchao.com.tw/coffee/en/')
      },

      toRegistration() {
        window.location.replace('https://www.chanchao.com.tw/en/invitation/?id=DCOF2022')
      },

      toLogin() {
        window.location.replace('https://www.chanchao.com.tw/coffee/onlineexpo/Login')
      },

      logout() {
        const vm = this
        const url = 'https://www.chanchao.com.tw/apiLogin/v1/Logout'

        vm.$http.get(url).then(function(response) {
          alert('Logout successfully')

          window.location.replace('https://www.chanchao.com.tw/coffee/onlineexpo/Landing')
        })
      },

      goLobby() {
        window.location.replace('https://www.chanchao.com.tw/coffee/onlineexpo/Home')
      },

      toOfficialUrl() {
        window.location.replace('https://www.chanchao.com.tw/coffee/')
      },
    },

    computed: {
      ...mapGetters(['exhcode']),
    },

    created() {
      const vm = this

      //取得當前時間

      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitions/A3BE580E0650B2734F902F75C0CE9BE2?lang=en`)
        .then((response) => {
          // console.log(response.data)

          vm.Nowdate = Date.parse(new Date()).valueOf()
          vm.ExpoBegin = response.data.OnlineExpoBegin
          vm.ExpoEnd = response.data.OnlineExpoEnd

          // console.log(vm.ExpoBegin)
          // console.log(vm.ExpoEnd)

          if (vm.Nowdate < vm.ExpoBegin) {
            vm.OnlineExpoStatus = 1
          } else if (vm.Nowdate >= vm.ExpoBegin && vm.Nowdate <= vm.ExpoEnd) {
            vm.OnlineExpoStatus = 2
          } else if (vm.Nowdate > vm.ExpoEnd) {
            vm.OnlineExpoStatus = 3
          }
        })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      })

      const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
      vm.$http.post(api).then((response) => {
        if (response.data == 200) {
          vm.isLogin = true

          const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/${vm.exhcode}`
          vm.$http.post(registerApi).then((response) => {
            // console.log(response.data)
            if (response.data == 200) {
              vm.isRegister = true
            } else if (response.data == 252) {
              vm.isRegister = true
            } else if (response.data == 251) {
              window.location.replace(`https://www.chanchao.com.tw/en/`)
            } else if (response.data == 253) {
              vm.isRegister = true
            } else if (response.data == 254) {
              vm.isRegister = true
            }
          })
        } else {
          vm.isLogin = false
        }
      })
    },
  }
</script>

<style lang="scss" scoped>
  .lobby_bg {
    background: url(../../assets/images/landing_bg.jpg);
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    background-size: cover;
    height: 900px;
  }

  // 未開放第一區

  .loginAllfont_1 {
    font-size: 30px;
    font-weight: bold;
  }

  .loginLinkfont_1 {
    font-size: 25px;
    font-weight: bold;
  }

  .loginTopfont_1 {
    font-size: 50px;
    color: yellow;
    font-style: italic;
  }

  .loginTimefont_1 {
    font-size: 35px;
    font-weight: 700;
  }

  .registerAllfont_1 {
    font-size: 29px;
    font-weight: bold;
  }

  .registerTopfont_1 {
    font-size: 46px;
    color: yellow;
    font-style: italic;
  }

  .doneAllfont_1 {
    font-size: 30px;
    font-weight: bold;
  }

  .doneTopfont_1 {
    font-size: 39px;
    color: yellow;
    font-style: italic;
  }

  // 已開展第二區

  .loginAllfont_2 {
    font-size: 30px;
    font-weight: bold;
  }

  .loginTopfont_2 {
    font-size: 38px;
    color: yellow;
    font-style: italic;
    font-weight: bold;
  }

  .loginTimefont_2 {
    font-size: 36px;
    font-weight: 700;
  }

  .registerAllfont_2 {
    font-size: 30px;
    font-weight: bold;
  }

  .registerTopfont_2 {
    font-size: 42px;
    color: yellow;
    font-style: italic;
  }

  .registerTimefont_2 {
    font-size: 38px;
    font-weight: 700;
  }

  // 畢展第三區

  .closeAllfont_3 {
    font-size: 30px;
    font-weight: bold;
  }

  .closeTopfont_3 {
    font-size: 52px;
    color: yellow;
    font-style: italic;
  }

  .titleMargin {
    margin-top: 88px;
  }

  .Opentime {
    font-size: 19px;
  }

  .loginLinkfont_1 {
    font-size: 21px;
  }

  @media screen and (min-width: 1150px) and (max-width: 1500px) {
    .Opentime {
      font-size: 17px;
    }

    .loginLinkfont_1 {
      font-size: 19px;
    }

    .loginAllfont_1 {
      font-size: 21px;
      font-weight: bold;
    }

    .loginLinkfont_1 {
      font-size: 18px;
      font-weight: bold;
    }

    .loginTopfont_1 {
      font-size: 30px;
      color: yellow;
      font-style: italic;
    }

    .loginTimefont_1 {
      font-size: 22px;
      font-weight: 700;
    }

    .registerAllfont_1 {
      font-size: 25px;
      font-weight: bold;
    }

    .registerTopfont_1 {
      font-size: 31px;
      color: yellow;
      font-style: italic;
    }

    .doneAllfont_1 {
      font-size: 22px;
      font-weight: bold;
    }

    .doneTopfont_1 {
      font-size: 30px;
      color: yellow;
      font-style: italic;
    }

    .loginAllfont_2 {
      font-size: 24px;
      font-weight: bold;
    }

    .loginTopfont_2 {
      font-size: 28px;
      color: yellow;
      font-style: italic;
    }

    .loginTimefont_2 {
      font-size: 25px;
      font-weight: 700;
    }

    .registerAllfont_2 {
      font-size: 25px;
      font-weight: bold;
    }

    .registerTopfont_2 {
      font-size: 28px;
      color: yellow;
      font-style: italic;
    }

    .registerTimefont_2 {
      font-size: 34px;
      font-weight: 700;
    }

    .closeAllfont_3 {
      font-size: 28px;
      font-weight: bold;
    }

    .closeTopfont_3 {
      font-size: 47px;
      color: yellow;
      font-style: italic;
    }
  }

  @media screen and (min-width: 577px) and (max-width: 1150px) {
    .Opentime {
      font-size: 15px;
    }

    .loginLinkfont_1 {
      font-size: 17px;
    }
    .loginTopfont_1 {
      font-size: 27px;
      color: yellow;
      font-style: italic;
    }
    .loginAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .loginLinkfont_1 {
      font-size: 18px;
      font-weight: bold;
    }
    .loginTimefont_1 {
      font-size: 26px;
      font-weight: 700;
    }

    .registerAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .registerTopfont_1 {
      font-size: 28px;
      color: yellow;
      font-style: italic;
    }

    .doneAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .doneTopfont_1 {
      font-size: 28px;
      color: yellow;
      font-style: italic;
    }

    .loginAllfont_2 {
      font-size: 20px;
      font-weight: bold;
    }

    .loginTopfont_2 {
      font-size: 26px;
      color: yellow;
      font-style: italic;
    }

    .loginTimefont_2 {
      font-size: 25px;
      font-weight: 700;
    }

    .registerAllfont_2 {
      font-size: 20px;
      font-weight: bold;
    }

    .registerTopfont_2 {
      font-size: 27px;
      color: yellow;
      font-style: italic;
    }

    .registerTimefont_2 {
      font-size: 26px;
      font-weight: 700;
    }

    .closeAllfont_3 {
      font-size: 20px;
      font-weight: bold;
    }

    .closeTopfont_3 {
      font-size: 30px;
      color: yellow;
      font-style: italic;
    }
  }

  @media screen and (max-width: 576px) {
    .Opentime {
      font-size: 14px;
    }

    .loginLinkfont_1 {
      font-size: 16px;
    }
    .titleMargin {
      margin-top: 50px;
    }

    .loginAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .loginLinkfont_1 {
      font-size: 16px;
      font-weight: bold;
    }

    .loginTopfont_1 {
      font-size: 27px;
      color: yellow;
      font-style: italic;
    }

    .loginTimefont_1 {
      font-size: 20px;
      font-weight: 700;
    }

    .registerAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .registerTopfont_1 {
      font-size: 23px;
      color: yellow;
      font-style: italic;
      margin-top: 20px;
    }

    .doneAllfont_1 {
      font-size: 20px;
      font-weight: bold;
    }

    .doneTopfont_1 {
      font-size: 26px;
      color: yellow;
      font-style: italic;
    }

    .loginAllfont_2 {
      font-size: 20px;
      font-weight: bold;
    }

    .loginTopfont_2 {
      font-size: 24px;
      color: yellow;
      font-style: italic;
    }

    .loginTimefont_2 {
      font-size: 24px;
      font-weight: 700;
    }

    .registerAllfont_2 {
      font-size: 20px;
      font-weight: bold;
    }

    .registerTopfont_2 {
      font-size: 24px;
      color: yellow;
      font-style: italic;
    }

    .registerTimefont_2 {
      font-size: 27px;
      font-weight: 700;
    }

    .closeAllfont_3 {
      font-size: 23px;
      font-weight: bold;
    }

    .closeTopfont_3 {
      font-size: 34px;
      color: yellow;
      font-style: italic;
    }
  }

  .lobby_banner {
    width: 600px;
    height: 350px;
    margin-top: 120px;
  }

  .small-font {
    font-size: 12px;
    -webkit-transform-origin-x: 0;
    transform: scale(0.9);
  }
</style>
